import IframeActivity from "./IframeActivity";

export default function VideoObservation() {
    return (
        <IframeActivity
            src="/activities/video-observation/index.html"
            title="Watch Closely"
        />
    );
}